<template>
  <div class="statistics-pg">
    <Search/>
    <v-container>
      <div class="breadcrumb-wrap">
        <v-breadcrumbs :items="breadcrumbs"/>
      </div>
      <div class="position">
        <div class="bg-white p-20">
          <h1 class="title-pg">{{ $t('Статистика по категориям') }}</h1>
          <div class="table-overflow">
            <table>
              <thead>
              <tr>
                <td
                  v-for="(item, index) in headerTable"
                  :key="index"
                >
                  <Sorting
                    v-if="item.sorting"
                    :item="item"
                    :currentOrderKey="sortKey"
                    @order="sortData($event)"
                    @cancelSorting="cancelSorting()"
                  />
                  <span v-else>
                    {{ item.name }}
                  </span>
                </td>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in statistics" :key="index">
                <td>{{ item.category }}</td>
                <td>{{ item.npas }}</td>
                <td>{{ item.comments }}</td>
                <td>{{ item.answers }}</td>
                <td>{{ item.expiredAnswers }}</td>
                <td>{{ item.commentsWithoutAnswers }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import Search from '@/components/Search'
import {mapMutations} from 'vuex'
import {Trans} from "@/plugins/Translation"
import mixin from '@/plugins/mixin/mixin'
import Sorting from "@/components/app/Sorting"
import PortalStatistics from "@/model/portalStatistic"

export default {
  mixins: [mixin],
  components: {
    Search,
    Sorting,
  },
  data: () => ({
    breadcrumbs: [],
    statistics: [],
    sortKey: 'npas',
    sortDir: 'desc',
  }),
  computed: {
    headerTable() {
      const fields = [
        {name: this.$t('Категория'), key: 'category', sorting: false},
        {name: this.$t('Количество размещенных проектов НПА'), key: 'npas', sorting: true},
        {name: this.$t('Количество  комментариев к размещенным проектам'), key: 'comments', sorting: true},
        {name: this.$t('Количество  ответов к комментариям'), key: 'answers', sorting: true},
        {name: this.$t('Количество ответов с нарушением сроков'), key: 'expiredAnswers', sorting: true},
        {name: this.$t('Количество неотвеченных комментариев'), key: 'commentsWithoutAnswers', sorting: true},
      ]
      return fields
    }
  },
  metaInfo() {
    return {
      title: this.$i18n.t('CategoryStatisticsTitleSEO'),
      meta: [{
        vmid: 'description',
        name: 'description',
        content: this.$i18n.t('CategoryStatisticsDescriptionSEO'),
      }, {
        vmid: 'keywords',
        name: 'keywords',
        content: this.$i18n.t('CategoryStatisticsKeywordsSEO'),
      }]
    }
  },
  mounted() {
    this.fetchData()
    this.scrollToTop()
  },
  methods: {
    ...mapMutations(['setLoading']),
    fetchData() {
      this.setLoading(true)
      this.breadcrumbs = [
        {text: this.$i18n.t('Главная'), disabled: false, href: Trans.currentLocaleUrl + '/'},
        {text: this.$i18n.t('Статистика портала'), disabled: false, href: Trans.currentLocaleUrl + '/statistics'},
        {text: this.$i18n.t('Статистика по категориям'), disabled: true}
      ]
      this.getStatistics()
      this.setLoading(false)
    },
    getStatistics() {
      this.setLoading(true)
      PortalStatistics.categoryStatistics({sortKey: this.sortKey, sortDir: this.sortDir}).then((response) => {
        console.log(response.data)
        this.statistics = response.data
        console.log(this.statistics)
      })
        .catch((error) => {
          this.$router.push(Trans.i18nRoute({
            name: 'error',
            params: {
              status: error.response.status
            }
          }))
        })
      this.setLoading(false)

    },
    sortData(sort) {
      this.sortKey = sort.key
      this.sortDir = sort.value
      this.getStatistics()
    },
    sortingFilterHandler(filter) {
      this.getStatistics()
    },
    // Прокручивание к началу страницы
    scrollToTop () {
      window.scrollTo(0, 0)
    },
    cancelSorting () {
      this.sortKey = 'npas'
      this.sortDir = 'desc'
      this.getStatistics()
    }
  }
}
</script>
